var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"الیاسل 🚀"}},[_c('b-card-text',[_vm._v("شروعی پر قدرت.")]),_c('b-card-text',[_vm._v("به ما بپیوندید "),_c('b-link',{attrs:{"href":"#","target":"_blank"}}),_vm._v(" و بهترین باشید!")],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }